import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { DesignMagazineRoomArticleI18nEditPresenter } from "./presenter";
import { useRoomI18nArticleQuery } from "../../model/repository/query/use-room-i18n-query";

type Props = {
	hotelID: string;
	roomID: string;
	langCode: LangCode;
};

export const DesignMagazineRoomArticleI18nEditContainer = memo(({ hotelID, roomID, langCode }: Props) => {
	const { data } = useRoomI18nArticleQuery({ hotelID, roomID, langCode });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<DesignMagazineRoomArticleI18nEditPresenter
			hotelID={hotelID}
			roomID={roomID}
			langCode={langCode}
			serverModel={data}
		/>
	);
});

DesignMagazineRoomArticleI18nEditContainer.displayName = "DesignMagazineRoomArticleI18nEdit";
